export default __webpack_public_path__ + "43f1053bc92ba5373a63b6b3dd3b3242.png";